/**
 * Global namespace for most components `dismiss` option.
 */
const dataBsDismiss = "data-bs-dismiss";
export default dataBsDismiss;
